import Footer from "../template/Footer";
import Header from "../template/Header";
import HomeSection from "../template/HomeSection";
import js from '../../assets/js.png'
import ai from '../../assets/ai.jpg'
import wordpress from '../../assets/wordPress.png'
import python from '../../assets/py1.png'
export default function Products() {
    return (
        <>
            <Header/>
            <HomeSection breadcrumb={`محصولات آموزشی`}/>
            <section id="teacher" className="teacher">

                <h1 className="heading heading-p">دوره های ما</h1>
                <h3 className="title title-p">کیفیت آموزش را از تیم ما بخوهید</h3>

                <div className="card-container">

                    <div className="card">
                        <img src={js} alt="" />
                        <h3> آموزش javascript</h3>
                        {/* <p>من عاشق تدریس هستم</p> */}
                        <a href="#"><button>خرید و شرکت در دوره</button></a>
                        <div className="icons">
                            <a href="#" className="fab fa-facebook-f"></a>
                            <a href="#" className="fab fa-twitter"></a>
                            <a href="#" className="fab fa-instagram"></a>
                            <a href="#" className="fab fa-github"></a>
                        </div>
                    </div>

                    <div className="card">
                        <img src={python} alt="" />
                        <h3>آموزش python</h3>
                        {/* <p>من عاشق تدریس هستم</p> */}
                        <a href="#"><button>خرید و شرکت در دوره</button></a>
                        <div className="icons">
                            <a href="#" className="fab fa-facebook-f"></a>
                            <a href="#" className="fab fa-twitter"></a>
                            <a href="#" className="fab fa-instagram"></a>
                            <a href="#" className="fab fa-github"></a>
                        </div>
                    </div>

                    <div className="card">
                        <img src={wordpress} alt="" />
                        <h3> آموزشwordpress</h3>
                        <a href="#"><button>خرید و شرکت در دوره</button></a>
                        {/* <p>من عاشق تدریس هستم</p> */}
                        <div className="icons">
                            <a href="#" className="fab fa-facebook-f"></a>
                            <a href="#" className="fab fa-twitter"></a>
                            <a href="#" className="fab fa-instagram"></a>
                            <a href="#" className="fab fa-github"></a>
                        </div>
                    </div>

                    <div className="card">
                        <img src={ai} alt="" />
                        <h3> آموزش هوش مصنوعی</h3>
                        {/* <p>من عاشق تدریس هستم</p> */}
                          <a href="#"><button>خرید و شرکت در دوره</button></a>
                        <div className="icons">
                            <a href="#" className="fab fa-facebook-f"></a>
                            <a href="#" className="fab fa-twitter"></a>
                            <a href="#" className="fab fa-instagram"></a>
                            <a href="#" className="fab fa-github"></a>
                        </div>
                    </div>

                </div>


            </section>

            {/* <section id="course" className="course">

                <h1 className="heading">دوره های ما</h1>
                <h3 className="title">مهارت های خود را با جدیدترین دوره ها ارتقا دهید</h3>


                <div className="box-container">

                    <div className="box">
                        <i className="fab fa-html5"></i>
                        <h3>html5</h3>
                        <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ </p>
                    </div>

                    <div className="box">
                        <i className="fab fa-css3-alt"></i>
                        <h3>css3</h3>
                        <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ </p>
                    </div>

                    <div className="box">
                        <i className="fab fa-js-square"></i>
                        <h3>javascript</h3>
                        <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ </p>
                    </div>

                    <div className="box">
                        <i className="fas fa-code"></i>
                        <h3>web development</h3>
                        <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ </p>
                    </div>

                    <div className="box">
                        <i className="fas fa-bullhorn"></i>
                        <h3>seo marketing</h3>
                        <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ </p>
                    </div>

                    <div className="box">
                        <i className="fas fa-paint-brush"></i>
                        <h3>graphic design</h3>
                        <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ </p>
                    </div>

                </div>

            </section> */}
            <Footer />

        </>
    )
}